import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
    MdArrowForwardIos,
    MdArrowBackIosNew,
    MdArticle,
    MdCalendarMonth,
    MdOndemandVideo,
    MdOutlineLocalLibrary,
    MdOutlinePeopleAlt,
    MdSchool,
    MdLeaderboard,
    MdPayment,
    MdMenuBook,
    MdAssignmentInd
} from 'react-icons/md';
import { GrScorecard } from "react-icons/gr";
import { useAuthContext } from 'context/AuthContext';

import Hamburger from './Hamburger';
import './index.css';

function Panel() {
    const [panelOpen, setPanelOpen] = useState(true);

    const { user } = useAuthContext();

    return (
        <div className={panelOpen ? 'panel' : 'panel--collapsed'}>
            <div className='panel__main'>
                {/* <h2 className='panel__header1'>
                    WellEd Labs
                </h2>
                <h2 className='panel__header2'>
                    TEST CENTER
                </h2> */}
                {(user && user.organizations && user.organizations[0].logo)
                ?   <img className='panel__logo' src={user.organizations[0].logo} />
                :   <>
                        <h2 className='panel__header2'>
                            TEST CENTER
                        </h2>
                        <h2 className='panel__header1'>
                            Admin Site
                        </h2>
                    </>
                }
                {user && (
                    (user.role === 'Super Admin' || user.role === 'Staff' || user.role === 'Admin')
                    ?   <h3 className='panel__badge--admin'>
                            admins
                        </h3>
                    :   user.role === 'Tutor'
                    ?   <h3 className='panel__badge--tutor'>
                            instructors
                        </h3>
                    :   <></>
                )}
            </div>
            {user &&
                <div className='panel__nav'>
                    <NavLink
                        to='/students'
                        className={({ isActive }) => 
                            isActive ? 'panel__navLink--active' : 'panel__navLink'
                        }
                    >
                        <MdOutlinePeopleAlt className='panel__navLinkIcon' />
                        <p className='panel__navLinkText'>Students</p>
                    </NavLink>
                    {((user.role === 'Admin' || user.role === 'Super Admin' || user.role === 'Staff') || (user.role === 'Tutor' && !(user.customizations.find(customization => customization === 'Hide Tutor Test Tab')))) &&  <>
                        <NavLink 
                            to='/tests'
                            className={({ isActive }) => 
                                isActive ? 'panel__navLink--active' : 'panel__navLink'
                            }
                        >
                            <MdArticle className='panel__navLinkIcon' />
                            <p className='panel__navLinkText'>Tests</p>
                        </NavLink>
                    </>}
                    <NavLink
                        to='/assignments'
                        className={({ isActive }) => 
                            isActive ? 'panel__navLink--active' : 'panel__navLink'
                        }
                    >
                        <MdCalendarMonth className='panel__navLinkIcon' />
                        <p className='panel__navLinkText'>Assignments</p>
                    </NavLink>
                    {user.customizations.find(customization => customization === 'Video Lectures') && 
                        <NavLink
                            to='/lectures'
                            className={({ isActive }) => 
                                isActive ? 'panel__navLink--active' : 'panel__navLink'
                            }
                        >
                            <MdOndemandVideo className='panel__navLinkIcon' />
                            <p className='panel__navLinkText'>Lectures</p>
                        </NavLink>
                    }
                    {!user.customizations.find(customization => customization === 'Hide Vocab') &&
                        <NavLink
                            to='/vocab'
                            className={({ isActive }) =>
                                isActive ? 'panel__navLink--active' : 'panel__navLink'
                            }
                        >
                            <MdMenuBook className='panel__navLinkIcon' />
                            <p className='panel__navLinkText'>Vocab</p>
                        </NavLink>
                    }
                    <NavLink
                        to='/latestScores'
                        className={({ isActive }) => 
                            isActive ? 'panel__navLink--active' : 'panel__navLink'
                        }
                    >
                        <MdLeaderboard className='panel__navLinkIcon' />
                        <p className='panel__navLinkText'>Latest Scores</p>
                    </NavLink>
                    {(user.role === 'Admin' || user.role === 'Super Admin' || user.role === 'Staff') && <>
                        <NavLink
                            to='/instructors'
                            className={({ isActive }) => 
                                isActive ? 'panel__navLink--active' : 'panel__navLink'
                            }
                        >
                            <MdSchool className='panel__navLinkIcon' />
                            <p className='panel__navLinkText'>Instructors</p>
                        </NavLink>
                    </>}
                    <NavLink
                        to='/classes'
                        className={({ isActive }) => 
                            isActive ? 'panel__navLink--active' : 'panel__navLink'
                        }
                    >
                        <MdOutlineLocalLibrary className='panel__navLinkIcon' />
                        <p className='panel__navLinkText'>Classes</p>
                    </NavLink>
                    {user.customizations.find(customization => customization === 'FillApp Enabled') &&
                        <NavLink
                            to='/college-apps'
                            className={({ isActive }) =>
                                isActive ? 'panel__navLink--active' : 'panel__navLink'
                            }
                        >
                            <MdAssignmentInd className='panel__navLinkIcon' />
                            <p className='panel__navLinkText'>College Apps</p>
                        </NavLink>
                    }
                    {(user.role === 'Admin' || user.role === 'Super Admin' || user.role === 'Staff') && <>
                        <NavLink
                            to='/credits'
                            className={({ isActive }) =>
                                isActive ? 'panel__navLink--active' : 'panel__navLink'
                            }
                        >
                            <MdPayment className='panel__navLinkIcon' />
                            <p className='panel__navLinkText'>Credits</p>
                        </NavLink>
                    </>}
                </div>
            }
            <Hamburger transparent={false}/>
            <div className='panel__handle' onClick={() => setPanelOpen(!panelOpen)}>
                {panelOpen
                    ? <MdArrowBackIosNew className='panel__handleIcon' />
                    : <MdArrowForwardIos className='panel__handleIcon' />
                }
            </div>
        </div>
    );
}

export default Panel;